import $ from 'jquery';

const showIfInputSelectedClass = '.js-show-if-row-input-selected';
const $showIfInputSelectedElements = $(showIfInputSelectedClass);
if ($showIfInputSelectedElements.length > 0) {
	$showIfInputSelectedElements.addClass('d-none');

	$showIfInputSelectedElements.each(function () {
		const $this = $(this);
		const radioButtonChangeCallback = function () {
			const $radio = $(this);
			$radio
				.closest('form')
				.find(showIfInputSelectedClass)
				.addClass('d-none');
			if ($radio.is(':checked')) {
				$this.removeClass('d-none');
			}
		};
		$this
			.closest('.row')
			.find('input[type=radio]')
			.on('change', radioButtonChangeCallback);
	});
}
